import { useState } from "react";

export default function Avatar({ src, name = "User", size = 40, style = {}, border = true }) {
  const [imgErr, setImgErr] = useState(false);
  if (!src || imgErr) {
    const initials = (name || "U").split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
    const colors = ["#E8593C", "#2557A7", "#0F6E56", "#b45309", "#7c3aed", "#0C1F3F"];
    const hash = name.charCodeAt(0) + name.charCodeAt(1 || 0);
    const bg = colors[hash % colors.length];
    return (
      <div style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.4,
        fontWeight: 800,
        color: "#fff",
        flexShrink: 0,
        border: border ? `2px solid ${bg}33` : "none",
        ...style
      }}>
        {initials}
      </div>
    );
  }
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: "50%",
      overflow: "hidden",
      flexShrink: 0,
      border: border ? `2px solid rgba(232,89,60,.15)` : "none",
      ...style
    }}>
      <img src={src} alt={name} onError={() => setImgErr(true)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    </div>
  );
}
